import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchFunctions, createFunction, updateFunction, deleteFunction } from "../api/adminService";

export const useFunctions = () => {
  const queryClient = useQueryClient();

  // ✅ Consulta optimizada para obtener las funciones
  const {
    data: functions = [], // Previene `undefined` al hacer `.map()`
    error,
    isLoading,
  } = useQuery({
    queryKey: ["functions"],
    queryFn: fetchFunctions,
    staleTime: 1000 * 60 * 5, // Cachea los datos por 5 minutos
    refetchOnWindowFocus: false, // Evita re-fetch cuando se cambia de ventana
    refetchOnMount: false, // No re-fetch al montar el componente si ya está en caché
    refetchOnReconnect: false, // Evita re-fetch al reconectar a la red
  });

  // ✅ Función reutilizable para invalidar la caché después de cada mutación
  const invalidateFunctionsCache = () => {
    queryClient.invalidateQueries({ queryKey: ["functions"] });
  };

  // ✅ Mutación para crear una función
  const createMutation = useMutation({
    mutationFn: createFunction,
    onSuccess: invalidateFunctionsCache,
  });

  // ✅ Mutación para actualizar una función
  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateFunction(id, data),
    onSuccess: invalidateFunctionsCache,
  });

  // ✅ Mutación para eliminar una función
  const deleteMutation = useMutation({
    mutationFn: deleteFunction,
    onSuccess: invalidateFunctionsCache,
  });

  return {
    functions, // Siempre un array seguro
    error,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
